"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = void 0;

var React = _interopRequireWildcard(require("react"));

var _utils = require("../utils");

var _ActionModal = require("../../ActionModal.styles");

var _locale = require("../../../../context/locale");

const Metadata = ({
  created,
  creator,
  updated
}) => {
  const {
    locale
  } = (0, _locale.useLocale)();
  const parsed = React.useMemo(() => (0, _utils.getReadableDates)(created, creator, updated, locale), [created, updated]);
  return /*#__PURE__*/React.createElement(_ActionModal.Activity, null, `${parsed.created}
        ${parsed.updated}`);
};

exports.Metadata = Metadata;